const getOriginLongName = state => state.location.origLngName
const getOriginShortName = state => state.location.origShrtName
const getOriginGooglePlaceId = state => state.location.originGooglePlaceId

const getDestinationLongName = state => state.location.destLngName
const getDestinationShortName = state => state.location.destShrtName
const getDestinationGooglePlaceId = state => state.location.destinationGooglePlaceId

export {
  getOriginLongName,
  getOriginShortName,
  getOriginGooglePlaceId,

  getDestinationLongName,
  getDestinationShortName,
  getDestinationGooglePlaceId,
}
